import Vue from 'vue';
import VueRouter  from 'vue-router';
import VueGtag from "vue-gtag";
import HelloWorld from './components/HelloWorld.vue'
Vue.use(VueRouter)

Vue.prototype.$order         = { store: [] }
Vue.prototype.$memberProfile = { store: false }
Vue.prototype.$events        = { store: [] }

function cmp(suffix) {
    return () => import(`./components/${suffix}.vue`);
}

const routes = [
    { path: '/',           component: HelloWorld},
    { path: '/about',      component: cmp('AboutUs')},
    { path: '/membership', component: cmp('Membership')},
    { path: '/history',    component: cmp('History')},
    { path: '/faq',        component: cmp('FAQ')},
    { path: '/tour',       component: cmp('Tour')},
    { path: '/next',       component: cmp('Next')},
    { path: '/reviews',    component: cmp('Reviews')},
    { path: '/members',    component: cmp('MemberPage'),
      children: [
          { path: 'home',         component: cmp('MemberHome'), alias:''  },
          { path: 'feature/:dir', component: cmp('Feature')},
          { path: 'archive/:dir', component: cmp('Archive')},
          { path: 'archive',      component: cmp('Archive')},
          { path: 'account',      component: cmp('Account')},
          { path: 'events',       component: cmp('Events')},
          { path: 'pdfviewer',    component: cmp('PdfViewer')},          
          { path: 'contacts',     component: cmp('Contacts')},
          { path: 'clubs',        component: cmp('Clubs')},
          { path: 'lunch',        component: cmp('Lunch')},
          { path: 'payment',      component: cmp('Payment')},
          { path: 'thanks',       component: cmp('ThankYou'), name: "ThankYou"},
          { path: 'national',     component: cmp('National'), name: "National"},
          { path: 'reserve',      component: cmp('Reserve'),  name: "Reservations"},
      ]
    }
]

export default new VueRouter({
    routes,scrollBehavior () {
        return { x: 0, y: 0 }
    }
})

var gaid = 'UA-443750-6';  // Dev
if ( document.location.pathname == '/main/' ) {
    gaid = 'UA-443750-5';  // Prod
}

Vue.use(VueGtag, {
  config: { 
      id: gaid
  }
});
